import { Message } from "shared/components/Message";
import React, { FC } from "react";
import { fatalErrorMessages } from "./errorMessages";

export interface IErrorIdentifier {
    identifier: number | string;
}

export const ErrorIdentifier: FC<IErrorIdentifier> = ({ identifier }) => {
    return (
        <strong data-testid="errorIdentifier">
            <Message message={fatalErrorMessages.defaultErrorIdentifierLabel} />
            &nbsp;
            <code className="text-dark" tabIndex={0}>{identifier}</code>
        </strong>
    );
};
